import { Action } from 'redux';
import { EnrollmentAppStateStructure } from '../../angular-elements/shared/interfaces/enrollmentAppStateStructure.interface';
import { ElectionInputStructure } from '../../angular-elements/shared/interfaces/electionInputStructure.interface';
import { Product } from 'src/app/angular-elements/plan-selection/interfaces/product.interface';
import { PlanAttributes, SummaryView } from 'src/app/angular-elements/plan-selection/interfaces/plan-attributes.interface';
import { APPLICANT_RELATION } from 'src/app/angular-elements/plan-selection/services/interfaces/shared/plan-demographics/applicant.interface';

export const ENROLLMENT_APP_STATE_NAME = 'EnrollmentApp';
export const INITIAL_STATE: EnrollmentAppStateStructure = {
  appId: '',
  submittedDate: null,
  submittedPlan: null,
  saveElectionAppIn: [{
    electionCode: '',
    eligibilityPeriodEndDate: '',
    eligibilityPeriodStartDate: '',
    finalIndicator: '',
    proposedEffectiveDate: [],
    questionInsertDate: '',
    questionNumber: '',
    questionValidIndicator: false
  }],
  submittedApplicantName: '',
  submittedEffectiveDate: '',
  extraInfo: {
    spouseRelation: null
  }
};

const SAVE_APPLICATION_SUBMISSION_INFO = 'SAVE_APPLICATION_SUBMISSION_INFO';
const SAVE_ELECTION_APPLICATION = 'SAVE_ELECTION_APPLICATION';
const PERSIST_ENROLLMENT_STATE = 'PERSIST_ENROLLMENT_STATE';
const SAVE_APP_ID = 'SAVE_APP_ID';
const SAVE_EXTRA_INFO = 'SAVE_EXTRA_INFO';

export class EnrollmentAppAction implements Action {
  type: string;
  appId?: string;
  saveElectionAppIn?: ElectionInputStructure[];
  submittedDate?: string;
  submittedPlan?: Product<PlanAttributes, SummaryView>;
  enrollmentApp?: EnrollmentAppStateStructure;
  extraInfo?: {
    spouseRelation?: APPLICANT_RELATION.SPOUSAL_PARTNER | APPLICANT_RELATION.DOMESTIC_PARTNER
  }
}

export function saveApplicationSubmissionInfo(enrollmentApp: EnrollmentAppStateStructure) {
  return {
    type: SAVE_APPLICATION_SUBMISSION_INFO, enrollmentApp 
  };
}

export function storeApplicationTrackingId(
  appId: string
) {
  return {
    type: SAVE_APP_ID,
    appId
  };
}

export function saveElectionAppIn(saveElectionApps: ElectionInputStructure[]) {
  return {
    type: SAVE_ELECTION_APPLICATION,
    saveElectionAppIn: saveElectionApps
  };
}

export function persistEnrollmentApp(enrollmentAppData: EnrollmentAppStateStructure): EnrollmentAppAction {
  return {
    type: PERSIST_ENROLLMENT_STATE,
    enrollmentApp: enrollmentAppData
  };
}

export function saveExtraInfo(extraInfo: { spouseRelation?: APPLICANT_RELATION.SPOUSAL_PARTNER | APPLICANT_RELATION.DOMESTIC_PARTNER }): EnrollmentAppAction {
  return {
    type: SAVE_EXTRA_INFO,
    extraInfo
  };
}

export function EnrollmentApp(state: EnrollmentAppStateStructure = INITIAL_STATE, action: EnrollmentAppAction) {
  const copiedState = JSON.parse(JSON.stringify(Object.assign({}, state)));
  switch (action.type) {
    case SAVE_APPLICATION_SUBMISSION_INFO:
      copiedState.appId = action.enrollmentApp.appId;
      copiedState.submittedDate = action.enrollmentApp.submittedDate;
      copiedState.submittedPlan = action.enrollmentApp.submittedPlan;
      copiedState.submittedApplicantName = action.enrollmentApp.submittedApplicantName;
      copiedState.submittedEffectiveDate = action.enrollmentApp.submittedEffectiveDate;
      // copiedState.saveElectionAppIn = action.enrollmentApp.saveElectionAppIn
      return Object.assign({}, state, copiedState);
    case SAVE_ELECTION_APPLICATION:
      copiedState.saveElectionAppIn = action.saveElectionAppIn;
      return Object.assign({}, state, copiedState);
    case PERSIST_ENROLLMENT_STATE:
      return Object.assign({}, state, action.enrollmentApp);
    case SAVE_APP_ID:
      copiedState.appId = action.appId;
      return Object.assign({}, state, copiedState);
    case SAVE_EXTRA_INFO:
      copiedState.extraInfo = action.extraInfo;
      return Object.assign({}, state, copiedState);
    default:
      return state;
  }
}
